export default "/assets/website/images/2008.jpeg?7daf919a34efc710911fae0508f5f29d";